export default __webpack_public_path__ + "static/media/service-walking.68c363d9.svg";